import { trackPromotionalEventsPdpPromoBannerClick } from "@faire/web-api/events/promotionalEvents/click/pdpPromoBanner";
import { trackRetailerTeamManagementInsiderMarketingPageLearnMoreRedirectClick } from "@faire/web-api/events/retailerTeamManagement/click/insiderMarketingPageLearnMoreRedirect";
import { IInformationMessage } from "@faire/web-api/indigofair/data/IInformationMessage";
import { IInsiderModalRequest } from "@faire/web-api/indigofair/insider/IInsiderModalRequest";
import insiderMarketingPage from "@faire/web-api/routes/user/insider/info";
import { getCurrentPath } from "@faire/web/common/Path";
import { Button } from "@faire/web/slate/Button";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React, { Suspense, useState } from "react";

import { LazyAutoEnrollModal } from "@faire/retailer/components/Notifications/Components/InsiderAutoEnrollBanner/LazyAutoEnrollModal";
import { useInsiderState } from "@faire/retailer/hooks/insider/useInsiderState";
import { useUserStore } from "@faire/retailer/stores/domain/UserStore";

export const CtaLink: React.FC<Partial<IInformationMessage>> = ({
  type,
  cta_text,
  help_link,
}) => {
  const { isInsiderAutoEnrollTrial, isInsiderActive } = useInsiderState();
  const { userCanPlaceOrder } = useUserStore(["userCanPlaceOrder"]);
  const [isModalShowing, setIsModalShowing] = useState(false);
  if (isInsiderActive && !isInsiderAutoEnrollTrial) {
    return null;
  }
  const isUpSellOrUnderThreshold =
    type === IInformationMessage.Type.INSIDER_UPSELL ||
    type === IInformationMessage.Type.INSIDER_UNDER_THRESHOLD;
  if (isUpSellOrUnderThreshold && isInsiderAutoEnrollTrial) {
    return (
      <>
        &nbsp;
        <Button
          variant="tertiary"
          onClick={() => {
            setIsModalShowing(true);
            trackPromotionalEventsPdpPromoBannerClick(
              IInformationMessage.Type.INSIDER_UPSELL
            );
          }}
          data-test-id="productPromoBannerInsiderLearnMoreButton"
        >
          {cta_text ?? ""}
        </Button>
        {isModalShowing ? (
          <Suspense fallback={null}>
            <LazyAutoEnrollModal
              onCloseModal={() => setIsModalShowing(false)}
            />
          </Suspense>
        ) : null}
      </>
    );
  }

  if (type === IInformationMessage.Type.INSIDER_UPSELL) {
    const link = !userCanPlaceOrder
      ? insiderMarketingPage()
      : getCurrentPath()
          .append({
            insiderEnrolment: IInsiderModalRequest.InsiderModalContext.PDP,
          })
          .toString();

    return (
      <>
        &nbsp;
        <Button
          variant="tertiary"
          linkTo={link}
          onClick={() => {
            if (!userCanPlaceOrder) {
              trackRetailerTeamManagementInsiderMarketingPageLearnMoreRedirectClick(
                "product-promo-banner"
              );
            }

            trackPromotionalEventsPdpPromoBannerClick(
              IInformationMessage.Type.INSIDER_UPSELL
            );
          }}
          data-test-id="productPromoBannerInsiderLearnMoreButton"
        >
          {cta_text ?? (
            <StrictLocalMsg
              defaultMessage="Learn more"
              description={{
                text: "Learn more CTA text",
                img: "https://cdn.faire.com/fastly/e4f39589e15d4068d73747cae8fb73e92f5805effe908d2827002bd56d474ae2.png",
              }}
            />
          )}
        </Button>
      </>
    );
  }

  return (
    <>
      {cta_text && help_link ? (
        <>
          <Button variant="tertiary" linkTo={help_link} target="_blank">
            {cta_text}
          </Button>
        </>
      ) : null}
    </>
  );
};
